import { FormationType } from "@/api/enums/FormationType";
import { ValidationStatus } from "@/api/enums/ValidationStatus";
import { perimeterSchema } from "@/components/molecules/PerimeterForm/PerimeterFormSchema";
import { file } from "@/constants/zodTypes";
import { Perimeter } from "@/lib/perimeter";
import { z } from "zod";

const formationAttestationSchema = z
  .object({
    formationType: z.nativeEnum(FormationType),
    formationInstituteId: z.number().nullable().optional(),
    certificate: file(),
    perimeter: perimeterSchema,
    status: z.nativeEnum(ValidationStatus).optional(),
  })
  .superRefine(({ formationType, formationInstituteId }, ctx) => {
    if (formationType === FormationType.NONE) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Vous devez sélectionner un type de formation",
        path: ["formationType"],
      });
    }
    if (
      formationType === FormationType.INSTITUTE &&
      formationInstituteId === -1
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Vous devez sélectionner un institut",
        path: ["formationInstituteId"],
      });
    }
  });

const formationAttestationsSchema = z.object({
  attestations: formationAttestationSchema.array(),
  allAttestationsProvided: z.boolean(),
});

const getFormationAttestationDefaultValues = (): z.infer<
  typeof formationAttestationSchema
> => ({
  formationInstituteId: -1,
  certificate: new File([""], ""),
  perimeter: Perimeter.empty(),
  status: undefined,
  formationType: FormationType.NONE,
});

type FormationAttestationsSchemaType = z.infer<
  typeof formationAttestationsSchema
>;

export {
  getFormationAttestationDefaultValues,
  formationAttestationSchema,
  formationAttestationsSchema,
};

export type { FormationAttestationsSchemaType };
